import Hash from "./Hash";
export default Hash;
